import { Box } from '@mui/material'
import React from 'react'
import { AdopterDto, AdoptionAttemptDtoStatus } from '../../../interactors/gen/backendClient'
import { OnGoingAdoptionItem } from './OnGoingAdoptionItem'
import { OnGoingAdoptionScreen } from './OnGoingAdoptionScreen'

interface Props {
  adopter: AdopterDto
}

export const AdopterOnGoingAdoptionTab: React.FC<Props> = ({ adopter }) => {
  const queryParams = new URLSearchParams(window.location.search)
  const attempts = adopter.adoptionAttempts?.filter(
    (adoptionAttempt) =>
      adoptionAttempt.status !== AdoptionAttemptDtoStatus.SuspendedByCustomer &&
      adoptionAttempt.status !== AdoptionAttemptDtoStatus.SuspendedByUser &&
      adoptionAttempt.done !== true &&
      adoptionAttempt.archived !== true
  )
  return queryParams.get('attemptId') != null ? (
    <OnGoingAdoptionScreen adopter={adopter} />
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        py: { xs: 2, md: 3 },
        px: { xs: 0, md: 0 },
      }}
    >
      {attempts && attempts.length > 0 ? (
        attempts.map((adoptionAttempt) => (
          <OnGoingAdoptionItem key={adoptionAttempt.id} adoptionAttempt={adoptionAttempt} />
        ))
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <span>Aucune adoption en cours</span>
        </Box>
      )}
    </Box>
  )
}
